import axios from "axios";
import ServerInfo, { PortsType } from "../viewModels/ServerInfo";
import buildingsInfoGenerate from "./buildingsInfoGenerate";
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import generateServersInfoByBuildings from "./generateServersInfoByBuildings";
export interface BuildingFetch {
  buildingId: string;
  buildingName: string;
  serverId: string;
  cloudServerId: string | null;
  userDisplayName: string;
  userId: string;
  publicAddress: string;
  cloudPublicAddress: string | null | undefined;
  localAddress: string | null | undefined;
  cloudPublicAddress: string | null | undefined;
  modules: string[];
  code: string;
  ports: PortsType;
}
const fetchUserBuildings = async (accessToken: string, serverUrl: string) => {
  var buildings: BuildingFetch[] | null = null;
  let servers: ServerInfo[] = await SecureStore.Servers.getServers();
  if (serverUrl && accessToken) {
    var severUrl = serverUrl;
    if (!severUrl.endsWith("/")) severUrl += "/";
    severUrl += "Buildings";
    try {
      buildings = (
        await axios.create().get(severUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
      ).data;
    } catch (error) {
      console.log("error in getUserBuildings", error, severUrl);
    }
    if (buildings && buildings.length > 0) {
      const newServersInfoByBuilding = await generateServersInfoByBuildings(
        buildings,
        accessToken,
        serverUrl
      );

      servers.forEach((serverElement: ServerInfo) => {
        newServersInfoByBuilding.forEach((newServerElement: ServerInfo) => {
          if (newServerElement.serverId !== serverElement.serverId) {
            servers.push(newServerElement);
          }
        });
      });
    }
    buildings = buildingsInfoGenerate(buildings);
  }
  return { buildings, servers };
};

export default fetchUserBuildings;
